export default function duration(seconds) {
  if (!seconds) return '0 s';

  //Seconds
  if (seconds < 60) return `${seconds} s`;

  //Minutes and Seconds
  if (seconds >= 60 && seconds < 3600) {
    return `${Math.floor(seconds / 60)} m ${seconds % 60} s`;
  }

  //Hours and Minutes
  if (seconds >= 3600 && seconds < 86400) {
    return `${Math.floor(seconds / 3600)} h ${Math.floor((seconds % 3600) / 60)} m`;
  }

  //Days and Hours
  if (seconds >= 86400) {
    return `${Math.floor(seconds / 86400)} days ${Math.floor((seconds % 86400) / 3600)} h`;
  }
}
